/* Real Shopify AJAX cart behind the demo site's drawer UI. */
(() => {
  // US shipping disclosure; checkout computes destination and post-discount eligibility.

  function updateCount(cart) {
    document.querySelectorAll('[data-cart-count]').forEach(el => { el.textContent = cart.item_count; });
  }
  function toast(message) {
    document.querySelector('.euna-toast')?.remove();
    const node = document.createElement('div');
    node.className = 'euna-toast';
    node.setAttribute('role', 'status');
    node.textContent = message;
    document.body.appendChild(node);
    window.setTimeout(() => node.remove(), 1600);
  }
  async function fetchCart() {
    const r = await fetch('/cart.js');
    return r.json();
  }
  function money(cents) {
    const n = cents / 100;
    return '$' + (Number.isInteger(n) ? n : n.toFixed(2));
  }
  function shipProgressHTML(cart) {
    return '<div class="ship-progress"><p>US shipping $6.95 · Free on $75+ after discounts.</p></div>';
  }
  function xsellPool() {
    const el = document.querySelector('script[data-euna-xsell]');
    if (!el) return [];
    try { return JSON.parse(el.textContent) || []; } catch (_) { return []; }
  }

  /* Affiliate attribution. Persists the active referral onto the cart so the
     order stays attributed even when the multi-buy automatic discount rejects
     the affiliate's code. Best effort: never block add-to-cart. */
  async function tagCartWithRef() {
    const ref = (window.EunaRef && window.EunaRef.get()) || null;
    if (!ref) return;
    try {
      await fetch('/cart/update.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ attributes: { ref } })
      });
    } catch (_) { /* attribution degrades, checkout must not */ }
  }

  window.EunaCart = {
    async add(variantId, qty = 1, title = '') {
      const r = await fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: Number(variantId), quantity: qty })
      });
      if (!r.ok) {
        const err = await r.json().catch(() => ({}));
        toast(err.description || 'Could not add to cart');
        return;
      }
      const item = await r.json();
      await tagCartWithRef();
      const cart = await fetchCart();
      updateCount(cart);
      openAddedSheet(item, cart, qty);
      document.dispatchEvent(new CustomEvent('euna:cart-changed', { detail: cart }));
    },
    async changeLine(line, quantity) {
      const r = await fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ line, quantity })
      });
      const cart = await r.json();
      updateCount(cart);
      document.dispatchEvent(new CustomEvent('euna:cart-changed', { detail: cart }));
      return cart;
    },
    async removeLine(line) {
      return this.changeLine(line, 0);
    }
  };

  /* Added-to-cart sheet: confirmation plus a quiet pairing suggestion. */
  function ensureSheet() {
    let layer = document.querySelector('.euna-sheet-layer');
    if (layer) return layer;
    layer = document.createElement('div');
    layer.className = 'euna-sheet-layer';
    layer.hidden = true;
    layer.innerHTML = `
      <button class="euna-sheet-scrim" type="button" aria-label="Close"></button>
      <div class="euna-sheet" role="dialog" aria-modal="true" aria-label="Added to cart">
        <div class="euna-sheet-head"><span class="euna-sheet-tick" aria-hidden="true">&#10003;</span><h2>Added to cart</h2><button class="euna-sheet-close" type="button" aria-label="Close">&times;</button></div>
        <div class="euna-sheet-item" data-sheet-item></div>
        <div class="euna-sheet-ship" data-sheet-ship></div>
        <div class="euna-sheet-ctas">
          <a class="euna-button primary" href="/checkout" style="display:block;text-align:center" data-sheet-checkout>Checkout now</a>
          <button class="euna-button" type="button" data-sheet-continue>Continue shopping</button>
        </div>
      </div>`;
    document.body.appendChild(layer);
    const close = () => { layer.hidden = true; document.body.style.overflow = ''; };
    layer.querySelector('.euna-sheet-scrim').addEventListener('click', close);
    layer.querySelector('.euna-sheet-close').addEventListener('click', close);
    layer.querySelector('[data-sheet-continue]').addEventListener('click', close);
    return layer;
  }
  function openAddedSheet(item, cart, qty) {
    const layer = ensureSheet();
    const img = item.image ? `<img src="${item.image}&width=160" alt="" onerror="this.src='${item.image}'">` : '<div></div>';
    layer.querySelector('[data-sheet-item]').innerHTML = `
      ${img}
      <div>
        <strong>${item.product_title}</strong>
        <small>${qty} × $${(item.final_price / 100).toFixed(2).replace(/\.00$/, '')}</small>
      </div>`;
    layer.querySelector('[data-sheet-ship]').innerHTML = shipProgressHTML(cart);
    layer.hidden = false;
    document.body.style.overflow = 'hidden';
    layer.querySelector('.euna-sheet-close').focus();
  }

  function closeCart() {
    const layer = document.querySelector('.euna-cart-layer');
    if (layer) layer.hidden = true;
    document.body.style.overflow = '';
  }
  function ensureCartLayer() {
    let layer = document.querySelector('.euna-cart-layer');
    if (layer) return layer;
    layer = document.createElement('div');
    layer.className = 'euna-cart-layer';
    layer.hidden = true;
    layer.innerHTML = `
      <button class="euna-cart-scrim" type="button" aria-label="Close cart"></button>
      <aside class="euna-cart-panel" aria-label="Shopping cart" aria-modal="true">
        <div class="euna-cart-head"><h2>Your cart</h2><button class="euna-cart-close" type="button" aria-label="Close cart">×</button></div>
        <div data-cart-ship></div>
        <div data-cart-items></div>
        <div class="euna-cart-summary"><div class="euna-cart-total"><span>Total</span><span data-cart-total>$0.00</span></div><a class="euna-button primary" style="width:100%;display:block;text-align:center" href="/checkout">Checkout</a></div>
      </aside>`;
    document.body.appendChild(layer);
    layer.querySelector('.euna-cart-scrim').addEventListener('click', closeCart);
    layer.querySelector('.euna-cart-close').addEventListener('click', closeCart);
    return layer;
  }
  async function renderCart() {
    const layer = ensureCartLayer();
    const cart = await fetchCart();
    const container = layer.querySelector('[data-cart-items]');
    layer.querySelector('[data-cart-ship]').innerHTML = cart.items.length ? shipProgressHTML(cart) : '';
    container.innerHTML = cart.items.length ? cart.items.map((item, i) => `
      <div class="euna-cart-item">
        ${item.image ? `<img src="${item.image}&width=136" alt="" onerror="this.src='${item.image}'">` : '<div></div>'}
        <div>
          <strong>${item.product_title}</strong>
          <small>$${(item.final_price / 100).toFixed(2)}</small>
          <div class="qty-step" data-line="${i + 1}">
            <button type="button" class="qty-btn" data-step="-1" aria-label="Decrease quantity">&minus;</button>
            <span class="qty-val">${item.quantity}</span>
            <button type="button" class="qty-btn" data-step="1" aria-label="Increase quantity">+</button>
          </div>
        </div>
        <button class="euna-cart-remove" type="button" data-remove="${i + 1}">Remove</button>
      </div>`).join('') : '<p class="euna-cart-empty">Your cart is empty.</p>';
    layer.querySelector('[data-cart-total]').textContent = `$${(cart.total_price / 100).toFixed(2)}`;
    container.querySelectorAll('[data-remove]').forEach(button => button.addEventListener('click', async () => {
      await window.EunaCart.removeLine(Number(button.dataset.remove));
      renderCart();
    }));
    updateCount(cart);
  }
  function openCart() {
    const layer = ensureCartLayer();
    renderCart();
    layer.hidden = false;
    document.body.style.overflow = 'hidden';
    layer.querySelector('.euna-cart-close').focus();
  }
  window.openCart = openCart;
  window.closeCart = closeCart;

  document.addEventListener('DOMContentLoaded', () => {
    document.querySelectorAll('[data-cart-open]').forEach(button => button.addEventListener('click', openCart));
    // grid card add-to-cart buttons carry the variant id
    document.addEventListener('click', (e) => {
      const btn = e.target.closest('[data-atc]');
      if (btn) {
        e.preventDefault();
        e.stopPropagation();
        window.EunaCart.add(btn.dataset.atc);
        return;
      }
      // quantity steppers: cart page reloads, drawer re-renders
      const step = e.target.closest('.qty-btn');
      if (step) {
        const wrap = step.closest('.qty-step');
        const line = Number(wrap.dataset.line);
        const val = Number(wrap.querySelector('.qty-val').textContent);
        const next = Math.max(0, val + Number(step.dataset.step));
        wrap.querySelectorAll('.qty-btn').forEach(b => { b.disabled = true; });
        window.EunaCart.changeLine(line, next).then(() => {
          if (step.closest('.euna-cart-layer')) renderCart();
          else window.location.reload();
        });
      }
    });
  });
  document.addEventListener('keydown', event => {
    if (event.key === 'Escape') {
      closeCart();
      const sheet = document.querySelector('.euna-sheet-layer');
      if (sheet) { sheet.hidden = true; document.body.style.overflow = ''; }
    }
  });
})();
